import { useState } from "react";
import { X } from "lucide-react";
import ModalScrim from "./ModalScrim";

/** Shared review & approval modal — same UX as tenant admin CRUD. */
export default function GovernanceApprovalModal({
  title,
  kicker = "REVIEW & APPROVAL",
  detail,
  summary = [],
  confirmLabel = "Approve & apply",
  onClose,
  onConfirm,
  testId = "governance-approval-modal",
}) {
  const [rationale, setRationale] = useState("");
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!(rationale || "").trim()) {
      setErr("Approval rationale is required.");
      return;
    }
    onConfirm(rationale.trim());
  };

  return (
    <ModalScrim testId={testId}>
      <form className="modal wide" onSubmit={submit}>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Close">
          <X size={18} />
        </button>
        <p className="kicker">{kicker}</p>
        <h2>{title}</h2>
        {detail && <p className="muted small-note">{detail}</p>}
        {summary.length > 0 && (
          <dl className="admin-review-dl">
            {summary.map((item) => (
              <div key={item.label} className="admin-review-row">
                <dt>{item.label}</dt>
                <dd>{item.value}</dd>
              </div>
            ))}
          </dl>
        )}
        <label>
          Approval rationale
          <textarea
            rows={3}
            required
            value={rationale}
            onChange={(e) => setRationale(e.target.value)}
            placeholder="Why is this change authorized?"
            data-testid={`${testId}-rationale`}
          />
        </label>
        {err && <p className="error-message">{err}</p>}
        <div className="login-actions">
          <button type="button" className="secondary-button" onClick={onClose}>Cancel</button>
          <button type="submit" className="primary-button" data-testid={`${testId}-confirm`}>
            {confirmLabel}
          </button>
        </div>
      </form>
    </ModalScrim>
  );
}
